import type { ComponentProps, ReactNode } from 'react'

import Link from 'next/link'

type UmbraLinkProps = ComponentProps<typeof Link>

// Internal links never jump to the top on their own: the page transition
// lets the old page fall into the hole first, then scrolls the new one into place
export const UmbraLink = ({ scroll = false, ...rest }: UmbraLinkProps): ReactNode => {
    return <Link scroll={scroll} {...rest} />
}
